module.exports = __webpack_public_path__ + "static/media/Group 93.7654d1a8.png";